<template>
  <div>
    <b-alert
      show
      variant="light"
      class="margin-bottom font14px icon-dark-custom"
    >
      <h6>ตรวจสอบการ Refer</h6>
      <div>
        {{ "บัตรประชาชน : " + this.MyCid }}
      </div>
      <div v-if="TmpDataNHSO.length <= 0">
        <h2 class="font-color-danger">ไม่พบข้อมูล</h2>
      </div>
      <div v-for="item in TmpDataNHSO" v-bind:key="item.id">
        <div class="margin-bottom4px">
          <b-button
            variant="warning"
            size="sm"
            @click="openBC(item[0].listDetail)"
            >ดูประวัติบน Ever Refer : {{ item[0].listDetail }}</b-button
          >
        </div>
        <b-table
          striped
          hover
          small
          :items="item"
          :fields="TmpfieldsNHSO"
          class="font14px"
          head-variant="dark"
          bordered
          responsive
        >
        </b-table>
      </div>
    </b-alert>
    <div class="d-block text-center">
      <b-button
        variant="info"
        size="sm"
        class="d-print-none"
        v-print="'#modal-ever-immigration-data'"
      >
        Print
      </b-button>
      &nbsp;
      <b-button
        size="sm"
        class="d-print-none"
        @click="$bvModal.hide('modal-ever-immigration-data')"
        >Close</b-button
      >
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DocumentScan from "@/models/patientEMRs/DocumentScan";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpDataNHSO: [],
      TmpfieldsNHSO: [],
      urlStrCid: "",
      urlStr: "",
      urlMain: ""
    };
  },
  props: ["MyCid"],
  component: {
    thaiDatetime,
    pjFunctions
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    this.setMophImmigration(this.MyCid);
  },
  watch: {
    MyCid: function() {
      this.setMophImmigration(this.MyCid);
    }
  },
  computed: {},
  methods: {
    openBC(bid) {
      window.open("https://refer.smpkhos.go.th/#/referral/" + bid, bid);
    },
    setMophImmigration(cid) {
      this.urlStrCid =
        "https://api.refer.evernetwork.io/external/api/v1/referIn/";

      this.urlMain = this.urlStrCid + this.MyCid;

      let ScrObj = this;

      this.axios
        .get(this.urlMain, {
          headers: {
            Authorization:
              "Bearer " + this.$store.get("systems@EverUser").ever_token
          }
        })
        .then(function(response) {
          ScrObj.output = response.data;

          if (ScrObj.output.referrals) {
            ScrObj.TmpDataNHSO = [];

            // console.log("MM", ScrObj.output.referrals);

            let data = [];
            for (var val of ScrObj.output.referrals) {
              data.push({
                list: "BC Id",
                listDetail: val.bid
              });

              data.push({
                list: "Referout Id",
                listDetail: val.referoutId
              });

              data.push({
                list: "Emergency Type",
                listDetail:
                  val.referoutEmergencyTypeName + " " + val.referoutTypeName
              });

              data.push({
                list: "วันที่ Refer",
                listDetail: val.referDateTime
              });

              data.push({
                list: "ชื่อ - สกุล",
                listDetail: val.ptname
              });

              data.push({
                list: "Hospital code",
                listDetail: val.fromHospCode
              });

              data.push({
                list: "pttypeName",
                listDetail: val.pttypeName
              });

              data.push({
                list: "preDiagnosis",
                listDetail: val.preDiagnosis
              });

              data.push({
                list: "requestText",
                listDetail: val.requestText
              });

              data.push({
                list: "refername",
                listDetail: val.refername
              });

              data.push({
                list: "icd",
                listDetail: val.icd + " : " + val.icdName
              });

              data.push({
                list: "Expire Date",
                listDetail: val.expireDateTime
              });

              ScrObj.TmpDataNHSO.push(data);
            }

            // console.log("MM", ScrObj.TmpDataNHSO);
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("moph-immigration : " + ScrObj.output);
        })
        .finally(function() {});
    },
    Arrayfilter(arData, ch) {
      var value = [];

      if (arData != null) {
        value = arData.filter(item => {
          return item.TRANSACTIONTYPE == ch;
        });
      } else {
        value = [];
      }

      return value;
    }
  }
})
export default class EmrCheckRefer extends Vue {}
</script>

<style lang="scss">
.alert {
  margin-bottom: 0px !important;
}

.icon-css {
  margin-right: 4px;
  float: left;
}
</style>

